import { toast as reactToastify, ToastOptions, TypeOptions } from 'react-toastify'

import { ReactNode } from 'react'

type ToastContent = string | number | ReactNode

const generateToastId = (content: ToastContent): string => {
    return String(content).trim()
}

const showToast = (
    content: ToastContent,
    type: TypeOptions,
    options?: ToastOptions
): void => {
    const toastId = options?.toastId ?? generateToastId(content)

    if (typeof reactToastify.isActive === 'function' && reactToastify.isActive(toastId)) {
        return
    }

    if (typeof reactToastify === 'function') {
        reactToastify(content, {
            ...options,
            type,
            toastId,
        })
    } else if (typeof (reactToastify as any)[type] === 'function') {
        // e.g. reactToastify.success
        ;(reactToastify as any)[type](content, {
            ...options,
            toastId,
        })
    } else {
        // fallback: try generic call or no-op
        try {
            (reactToastify as any)(content, {
                ...options,
                type,
                toastId,
            })
        } catch (e) {
            // swallow in test env
        }
    }
}

export const toast = {
    success: (content: ToastContent, options?: ToastOptions): void => {
        showToast(content, 'success', options)
    },
    error: (content: ToastContent, options?: ToastOptions): void => {
        showToast(content, 'error', options)
    },
    info: (content: ToastContent, options?: ToastOptions): void => {
        showToast(content, 'info', options)
    },
    warning: (content: ToastContent, options?: ToastOptions): void => {
        showToast(content, 'warning', options)
    },
    dismiss: typeof reactToastify.dismiss === 'function' ? reactToastify.dismiss : () => undefined,
    isActive: typeof reactToastify.isActive === 'function' ? reactToastify.isActive : () => false,
}
